import { Link, useLocation } from '@tanstack/react-router'

import { Logo } from '@/components/layout/logo'

function pageName(pathname: string) {
  if (pathname.startsWith('/q/')) return 'Your quote'
  if (pathname.startsWith('/i/')) return 'Your invoice'
  return 'Order tracker'
}

export function PortalHeader() {
  const { pathname } = useLocation()
  return (
    <header className="border-b bg-card">
      <div className="mx-auto flex w-full max-w-5xl items-center justify-between gap-4 px-5 py-3 sm:px-6">
        <Link to="/" className="flex items-center gap-3">
          <Logo className="h-9 w-auto" />
          <span className="text-muted-foreground hidden border-l pl-3 text-sm sm:inline">{pageName(pathname)}</span>
        </Link>
        {/* eslint-disable-next-line no-restricted-syntax -- external URL */}
        <a
          href="https://shopusars.com"
          className="text-muted-foreground hover:text-foreground hidden text-sm sm:inline"
          target="_blank"
          rel="noreferrer"
        >
          shopusars.com
        </a>
      </div>
    </header>
  )
}
